module.exports = "/assets/images/aea46cecb9f88e3da4d69c29b2522258.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_down.svg
// module id = p3Pm
// module chunks = 0